import React from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useContactFormStyles } from "./ContactForm.styles";
import FormTextField from "../../../../ui/form/FormTextField";
import FormCheckBox from "../../../../ui/form/FormCheckBox";
import { useContactForm } from "../../../../../hooks/useContactForm";
import { useI18n } from "../../../../../i8n/useI18n";

const ContactForm = () => {
    const { classes } = useContactFormStyles();
    const { t } = useI18n();
    const { form, errors, loading, success, serverError, handleChange, handleSubmit } = useContactForm();

    return (
        <Box className={classes.root}>
            {success ? (
                <Alert severity="success" className={classes.successAlert}>
                    {t("contactPage.form.successMessage")}
                </Alert>
            ) : (
                <Box className={classes.fields}>
                    <FormTextField
                        label={t("contactPage.form.name.label")}
                        placeholder={t("contactPage.form.name.placeholder")}
                        value={form.name}
                        onChange={handleChange("name")}
                        error={!!errors.name}
                        helperText={t("contactPage.form.name.helperText")}
                    />
                    <FormTextField
                        label={t("contactPage.form.email.label")}
                        placeholder={t("contactPage.form.email.placeholder")}
                        value={form.email}
                        onChange={handleChange("email")}
                        error={!!errors.email}
                        helperText={t("contactPage.form.email.helperText")}
                        type="email"
                    />
                    <FormTextField
                        label={t("contactPage.form.message.label")}
                        placeholder={t("contactPage.form.message.placeholder")}
                        value={form.message}
                        onChange={handleChange("message")}
                        error={!!errors.message}
                        helperText={t("contactPage.form.message.helperText")}
                        multiline
                        rows={5}
                    />
                    <FormCheckBox
                        checked={form.terms}
                        onChange={handleChange("terms") as any}
                        error={!!errors.terms}
                        label={
                            <>
                                {t("contactPage.form.terms")}
                                <Typography
                                    component={RouterLink}
                                    to={t("links.privacy")}
                                    sx={{ color: "primary.main", ml: 0.5, fontSize: "inherit" }}
                                >
                                    {t("contactPage.form.termsLink")}
                                </Typography>
                            </>
                        }
                    />
                    {serverError && (
                        <Alert severity="error" className={classes.errorAlert}>
                            {t("contactPage.form.errorMessage")}
                        </Alert>
                    )}
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSubmit}
                        disabled={loading}
                        className={classes.submitBtn}
                        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                    >
                        {loading ? t("common.loading") : t("contactPage.form.submit")}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default ContactForm;
